import { DomainEvent } from "@/domains/events"

import type { FeatureFlagId } from "./types"

export class FeatureFlagEnabledEvent extends DomainEvent {
  static readonly TYPE = "feature-flag.enabled"
  readonly type = FeatureFlagEnabledEvent.TYPE

  constructor(
    public readonly payload: {
      flagId: FeatureFlagId
    },
  ) {
    super()
  }
}

export class FeatureFlagDisabledEvent extends DomainEvent {
  static readonly TYPE = "feature-flag.disabled"
  readonly type = FeatureFlagDisabledEvent.TYPE

  constructor(
    public readonly payload: {
      flagId: FeatureFlagId
    },
  ) {
    super()
  }
}
